import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView, trackEvent } from '../utils/analytics';

export const useAnalytics = () => {
  const location = useLocation();

  // Track page views when location changes
  useEffect(() => {
    if (location.pathname) {
      trackPageView(location.pathname);
    }
  }, [location]);

  return {
    trackEvent,
    trackPageView: () => trackPageView(location.pathname),
  };
}; 